'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icons = require('./icons');

var _getBackgroundColor = require('./getBackgroundColor');

var _getBackgroundColor2 = _interopRequireDefault(_getBackgroundColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Switch = function (_Component) {
  _inherits(Switch, _Component);

  function Switch(props) {
    _classCallCheck(this, Switch);

    var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));

    _this.handleDragStart = _this.handleDragStart.bind(_this);
    _this.handleDrag = _this.handleDrag.bind(_this);
    _this.handleDragStop = _this.handleDragStop.bind(_this);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleTouchCancel = _this.handleTouchCancel.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);

    var height = props.height,
        width = props.width,
        handleDiameter = props.handleDiameter,
        checked = props.checked;

    _this.handleDiameter = handleDiameter || height - 2;
    _this.checkedPos = Math.max(width - height, width - (height + _this.handleDiameter) / 2);
    _this.uncheckedPos = Math.max(0, (height - _this.handleDiameter) / 2);
    _this.state = {
      pos: checked ? _this.checkedPos : _this.uncheckedPos,
      startX: null,
      isDragging: false,
      hasOutline: false
    };
    return _this;
  }

  _createClass(Switch, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var checked = _ref.checked;

      var pos = checked ? this.checkedPos : this.uncheckedPos;
      this.setState({ pos: pos });
    }
  }, {
    key: 'handleDragStart',
    value: function handleDragStart(clientX) {
      this.setState({ startX: clientX, hasOutline: true });
    }
  }, {
    key: 'handleDrag',
    value: function handleDrag(clientX) {
      var startX = this.state.startX;
      var checked = this.props.checked;


      var startPos = checked ? this.checkedPos : this.uncheckedPos;
      var newPos = startPos + clientX - startX;
      var pos = Math.min(this.checkedPos, Math.max(this.uncheckedPos, newPos));
      this.setState({ pos: pos, isDragging: true });
    }
  }, {
    key: 'handleDragStop',
    value: function handleDragStop() {
      var _state = this.state,
          pos = _state.pos,
          isDragging = _state.isDragging;
      var _props = this.props,
          checked = _props.checked,
          onChange = _props.onChange;

      // Simulate clicking the handle

      if (!isDragging) {
        this.setState({ startX: null, hasOutline: false });
        onChange(!checked);
        return;
      }
      if (checked) {
        if (pos > (this.checkedPos + this.uncheckedPos) / 2) {
          this.setState({ pos: this.checkedPos, startX: null, isDragging: false, hasOutline: false });
          return;
        }
        this.setState({ startX: null, isDragging: false, hasOutline: false });
        onChange(false);
        return;
      }
      if (pos < (this.checkedPos + this.uncheckedPos) / 2) {
        this.setState({ pos: this.uncheckedPos, startX: null, isDragging: false, hasOutline: false });
        return;
      }
      this.setState({ startX: null, isDragging: false, hasOutline: false });
      onChange(true);
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      // Ignore right click and scroll
      if (typeof event.button === 'number' && event.button !== 0) {
        return;
      }

      this.handleDragStart(event.clientX);
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      event.preventDefault();
      this.handleDrag(event.clientX);
    }
  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      this.handleDragStop();
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }

    // TODO: Prevent mouse events from triggering on touch events.

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      this.handleDragStart(event.touches[0].clientX);
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      this.handleDrag(event.touches[0].clientX);
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      event.preventDefault();
      this.handleDragStop();
    }
  }, {
    key: 'handleTouchCancel',
    value: function handleTouchCancel() {
      this.setState({ startX: null, hasOutline: false });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _props2 = this.props,
          checked = _props2.checked,
          onChange = _props2.onChange;

      onChange(!checked);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      var _props3 = this.props,
          checked = _props3.checked,
          onChange = _props3.onChange;
      var isDragging = this.state.isDragging;
      // Trigger change on spacebar and enter keys (in violation of wai-aria spec).

      if ((event.keyCode === 32 || event.keyCode === 13) && !isDragging) {
        event.preventDefault();
        onChange(!checked);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          checked = _props4.checked,
          disabled = _props4.disabled,
          className = _props4.className,
          offColor = _props4.offColor,
          onColor = _props4.onColor,
          offHandleColor = _props4.offHandleColor,
          onHandleColor = _props4.onHandleColor,
          checkedIcon = _props4.checkedIcon,
          uncheckedIcon = _props4.uncheckedIcon,
          boxShadow = _props4.boxShadow,
          activeBoxShadow = _props4.activeBoxShadow,
          height = _props4.height,
          width = _props4.width,
          id = _props4.id,
          ariaLabelledby = _props4['aria-labelledby'],
          ariaLabel = _props4['aria-label'];
      var _state2 = this.state,
          pos = _state2.pos,
          isDragging = _state2.isDragging,
          hasOutline = _state2.hasOutline;


      var rootStyle = {
        position: 'relative',
        display: 'inline-block',
        opacity: disabled ? 0.5 : 1,
        borderRadius: height / 2,
        WebkitTransition: 'opacity 0.25s',
        MozTransition: 'opacity 0.25s',
        transition: 'opacity 0.25s'
        // width
      };

      var backgroundStyle = {
        height: height,
        width: width,
        margin: Math.max(0, (this.handleDiameter - height) / 2),
        position: 'relative',
        cursor: disabled ? 'default' : 'pointer',
        background: (0, _getBackgroundColor2.default)(pos, this.checkedPos, this.uncheckedPos, offColor, onColor),
        borderRadius: height / 2,
        WebkitTransition: isDragging ? null : 'background 0.25s',
        MozTransition: isDragging ? null : 'background 0.25s',
        transition: isDragging ? null : 'background 0.25s'
      };

      var checkedStyle = {
        position: 'relative',
        opacity: (pos - this.uncheckedPos) / (this.checkedPos - this.uncheckedPos),
        width: Math.min(height * 1.5, width - (this.handleDiameter + height) / 2 + 1),
        height: height,
        pointerEvents: 'none',
        WebkitTransition: isDragging ? null : 'opacity 0.25s',
        MozTransition: isDragging ? null : 'opacity 0.25s',
        transition: isDragging ? null : 'opacity 0.25s'
      };

      var uncheckedStyle = {
        opacity: 1 - (pos - this.uncheckedPos) / (this.checkedPos - this.uncheckedPos),
        width: Math.min(height * 1.5, width - (this.handleDiameter + height) / 2 + 1),
        height: height,
        position: 'absolute',
        right: 0,
        top: 0,
        pointerEvents: 'none',
        WebkitTransition: isDragging ? null : 'opacity 0.25s',
        MozTransition: isDragging ? null : 'opacity 0.25s',
        transition: isDragging ? null : 'opacity 0.25s'
      };

      var handleStyle = {
        height: this.handleDiameter,
        width: this.handleDiameter,
        background: (0, _getBackgroundColor2.default)(pos, this.checkedPos, this.uncheckedPos, offHandleColor, onHandleColor),
        touchAction: 'none',
        cursor: disabled ? 'default' : 'pointer',
        WebkitTransition: isDragging ? null : 'background-color 0.25s, left 0.25s, box-shadow 0.1s',
        MozTransition: isDragging ? null : 'background-color 0.25s, left 0.25s, box-shadow 0.1s',
        transition: isDragging ? null : 'background-color 0.25s, left 0.25s, box-shadow 0.1s',
        display: 'inline-block',
        borderRadius: '50%',
        position: 'absolute',
        left: pos,
        top: Math.max(0, (height - this.handleDiameter) / 2),
        border: 0,
        outline: 0,
        boxShadow: hasOutline ? activeBoxShadow : boxShadow
      };

      return _react2.default.createElement(
        'div',
        { className: className, style: rootStyle },
        _react2.default.createElement(
          'div',
          {
            className: 'react-switch-bg',
            style: backgroundStyle,
            onClick: disabled ? null : this.handleClick
          },
          checkedIcon ? _react2.default.createElement(
            'div',
            { style: checkedStyle },
            checkedIcon
          ) : null,
          uncheckedIcon ? _react2.default.createElement(
            'div',
            { style: uncheckedStyle },
            uncheckedIcon
          ) : null
        ),
        _react2.default.createElement('div', {
          className: 'react-switch-handle',
          role: 'checkbox',
          tabIndex: disabled ? null : 0,
          onMouseDown: disabled ? null : this.handleMouseDown,
          onTouchStart: disabled ? null : this.handleTouchStart,
          onTouchMove: disabled ? null : this.handleTouchMove,
          onTouchEnd: disabled ? null : this.handleTouchEnd,
          onTouchCancel: disabled ? null : this.handleTouchCancel,
          onKeyDown: this.handleKeyDown,
          onFocus: function onFocus() {
            return _this2.setState({ hasOutline: true });
          },
          onBlur: function onBlur() {
            return _this2.setState({ hasOutline: false });
          },
          onTransitionEnd: this.handleTransitionEnd,
          style: handleStyle,
          id: id,
          'aria-checked': checked,
          'aria-disabled': disabled,
          'aria-labelledby': ariaLabelledby,
          'aria-label': ariaLabel
        })
      );
    }
  }]);

  return Switch;
}(_react.Component);

Switch.propTypes = {
  checked: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool,
  offColor: _propTypes2.default.string,
  onColor: _propTypes2.default.string,
  offHandleColor: _propTypes2.default.string,
  onHandleColor: _propTypes2.default.string,
  handleDiameter: _propTypes2.default.number,
  uncheckedIcon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element]),
  checkedIcon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element]),
  boxShadow: _propTypes2.default.string,
  activeBoxShadow: _propTypes2.default.string,
  height: _propTypes2.default.number,
  width: _propTypes2.default.number,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  'aria-labelledby': _propTypes2.default.string,
  'aria-label': _propTypes2.default.string
};

Switch.defaultProps = {
  disabled: false,
  offColor: '#888',
  onColor: '#080',
  offHandleColor: '#fff',
  onHandleColor: '#fff',
  handleDiameter: null,
  uncheckedIcon: _icons.uncheckedIcon,
  checkedIcon: _icons.checkedIcon,
  boxShadow: null,
  activeBoxShadow: '0px 0px 2px 3px #33bbff',
  height: 28,
  width: 56,
  className: null,
  id: null,
  'aria-labelledby': null,
  'aria-label': null
};

exports.default = Switch;